import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import "rxjs/add/observable/zip";

@Injectable()
export class ReminderService {
  reminders = undefined;
  constructor(private db: AngularFireDatabase) { }

  getReminders(communityId): any {
    return this.db.list(`/reminders/${communityId}`).valueChanges()
      .map((data: any) => {
        if (!data.length) {
          return false;
        }

        return data.map(reminder => {
          const $serviceName = this.db.object(`/billtypes/${reminder.serviceId}/name`).valueChanges();

          return Observable.zip($serviceName, serviceName => {
            return {
              id: reminder.id,
              serviceId: reminder.serviceId,
              billType: serviceName,
              currentRollOutDay: reminder.currentRollOutDay,
              outstandingRollOutDay: reminder.outstandingRollOutDay
            };
          });
        });
      }).flatMap(reminder => {
        if (!reminder) {
          return Observable.of([]);
        }

        return Observable.combineLatest(reminder);
      });
  }

  getReminderById(reminderId): any {
    return this.db.object(`/reminders/${reminderId}`).valueChanges();
  }

  update(communityId, reminder): any {
    return this.db.list(`/reminders/${communityId}`).update(reminder.id, reminder);
  }

  delete(communityId, reminderId): any {
    return this.db.list(`/reminders/${communityId}/${reminderId}`).remove();
  }

  create(communityId, reminder): any {
    return this.db
      .list(`/reminders/${communityId}`)
      .push(reminder)
      .then(data => {
        reminder.id = data.key;

        return this.db
          .list(`/reminders/${communityId}`)
          .update(data.key, reminder);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/reminder/reminder.service.ts